import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  SpeechIndustryHealthcare,
  SpeechIndustyFintech,
  SpeechIndustyElearning,
  SpeechIndustryEntertainment,
  SpeechIndustryAutomative,
  SpeechIndustryGovernment,
} from "../../../app-constants";

function Speechindustries() {
  return (
    <section
      className="speech_industries p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Industries We Serve with Speech Recognition Solutions</h2>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="offset-lg-1">
            <p>
              Having proven expertise in voice recognition software development,
              we offer our services in various domains including:
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="speech_industtries_box">
                  <div className="speech_industtries_main">
                    <div className="speech_industtries_svg">
                      {SpeechIndustryHealthcare}
                    </div>
                    <div className="speech_industtries_head">
                      <h5>Healthcare</h5>
                    </div>
                  </div>
                  <div className="speech_industtries_list">
                    <ul>
                      <li>
                        Automate medical transcription and reduce administrative
                        workload.
                      </li>
                      <li>
                        Enable voice-activated systems for accurate patient
                        interactions.
                      </li>
                      <li>
                        Ensure precise entry of medical records and patient
                        information.
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="speech_industtries_box">
                  <div className="speech_industtries_main">
                    <div className="speech_industtries_svg">
                      {SpeechIndustyFintech}
                    </div>
                    <div className="speech_industtries_head">
                      <h5>Fintech</h5>
                    </div>
                  </div>
                  <div className="speech_industtries_list">
                    <ul>
                      <li>
                        Implement voice biometrics for secure authentication in
                        transactions.
                      </li>
                      <li>
                        Deploy voice self-service systems for inquiries and
                        transactions.
                      </li>
                      <li>
                        Utilize speech analytics for insights from customer
                        interactions.
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="speech_industtries_box">
                  <div className="speech_industtries_main">
                    <div className="speech_industtries_svg">
                      {SpeechIndustyElearning}
                    </div>
                    <div className="speech_industtries_head">
                      <h5>eLearning</h5>
                    </div>
                  </div>
                  <div className="speech_industtries_list">
                    <ul>
                      <li>
                        Provide voice-activated tools for interactive
                        educational experiences.
                      </li>
                      <li>
                        Enhance accessibility through speech recognition
                        technologies.
                      </li>
                      <li>
                        Offer real-time, voice-based feedback and assessment.
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="speech_industtries_box">
                  <div className="speech_industtries_main">
                    <div className="speech_industtries_svg">
                      {SpeechIndustryEntertainment}
                    </div>
                    <div className="speech_industtries_head">
                      <h5>Entertainment</h5>
                    </div>
                  </div>
                  <div className="speech_industtries_list">
                    <ul>
                      <li>
                        Enable media control and content navigation with voice
                        commands.
                      </li>
                      <li>
                        Create voice-driven interfaces for gaming and virtual
                        reality.
                      </li>
                      <li>
                        Integrate voice synthesis for character voices and
                        storytelling.
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="speech_industtries_box">
                  <div className="speech_industtries_main">
                    <div className="speech_industtries_svg">
                      {SpeechIndustryAutomative}
                    </div>
                    <div className="speech_industtries_head">
                      <h5>Automotive</h5>
                    </div>
                  </div>
                  <div className="speech_industtries_list">
                    <ul>
                      <li>
                        Facilitate hands-free communication and infotainment
                        control.
                      </li>
                      <li>
                        Enhance navigation systems with voice commands and
                        updates.
                      </li>
                      <li>
                        Improve vehicle diagnostics and maintenance reporting.
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="speech_industtries_box">
                  <div className="speech_industtries_main">
                    <div className="speech_industtries_svg">
                      {SpeechIndustryGovernment}
                    </div>
                    <div className="speech_industtries_head">
                      <h5>Government</h5>
                    </div>
                  </div>
                  <div className="speech_industtries_list">
                    <ul>
                      <li>Automate transcription of meetings and hearings.</li>
                      <li>
                        Enhance public services with voice-activated information
                        systems.
                      </li>
                      <li>
                        Improve accessibility with voice recognition solutions.
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Speechindustries;
